
export default function InfoPage04(props) {
  return (
    <div className="text-center">
      <h2>Thank you for your time.</h2>
      <p>You may now close this window. <br /> Submit ID: {props.data}</p>
    </div>
  );
}
